/**
 * Auth token module — Phase B (cookie-only, 2026-02-27).
 *
 * History:
 *   * Phase 0 (legacy): JWT in localStorage + `Authorization: Bearer` header.
 *   * Phase A (2026-02-20): added httpOnly `tm_auth` cookie. Dual-path —
 *     localStorage still cached for `?token=…` download links.
 *   * Phase B (current): cookie is the SOLE auth source. localStorage is no
 *     longer read or written. `?token=…` query params are gone from every
 *     frontend URL. XSS-exfil vector closed.
 *
 * These exports remain as no-ops so any straggling caller (or external
 * extension) keeps compiling. They also one-shot CLEAN the legacy `tr_token`
 * out of every existing user's localStorage on next page load.
 */

const LEGACY_STORAGE_KEY = "tr_token";

let _migrated = false;
function _migrateOnce() {
    if (_migrated) return;
    _migrated = true;
    try {
        if (typeof localStorage !== "undefined" && localStorage.getItem(LEGACY_STORAGE_KEY)) {
            localStorage.removeItem(LEGACY_STORAGE_KEY);
        }
    } catch (err) {
        console.warn("[auth] legacy token cleanup failed:", err?.message || err);
    }
}

/** @deprecated cookie-only auth — always returns "". */
export function getToken() {
    _migrateOnce();
    return "";
}

/** @deprecated cookie-only auth — no-op (cleans any legacy token). */
export function setToken(/* token */) {
    _migrateOnce();
}

/** Clears the (legacy) localStorage entry, if any. Server cookie is cleared
 *  separately by `POST /api/auth/logout`. */
export function clearToken() {
    _migrateOnce();
}

/** @deprecated returns the URL unchanged — cookie is auto-sent on same-origin
 *  navigations. Kept as a no-op so existing call-sites don't blow up. */
export function withTokenQuery(url) {
    return url;
}
